export default {
	data(){
		return {
			tableGBoptions: { 
				options: {editar: 'Editar Usuario', inactivar: 'Inactivar Usuario'},
				modals: []
			},

			tableGBSearch: ['users/name'],
			
			tableGBItems: [				
				{
					thead: { th: 'Usuario', sort: null, sortTable: 'users/name'},
					tbody: { td: ['users/name'],}
				},
				{
					thead: { th: 'Email', },
					tbody: { td: ['users/email'],}
				},
			]			
		}
	},
}